import { render, staticRenderFns } from "./realVoiceCustomer.vue?vue&type=template&id=f9231b32&scoped=true&"
import script from "./realVoiceCustomer.ts?vue&type=script&lang=js&"
export * from "./realVoiceCustomer.ts?vue&type=script&lang=js&"
import style0 from "./realVoiceCustomer.less?vue&type=style&index=0&id=f9231b32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9231b32",
  null
  
)

export default component.exports